import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#FFDA44\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#FF9811\" d=\"M9.391 2.086H5.237q-.277.189-.541.393l-1.044 9.52 1.044 9.52q.265.204.54.393h4.155z\"></path><path fill=\"#6DA544\" d=\"M0 12a11.98 11.98 0 0 0 4.696 9.521V2.48A11.98 11.98 0 0 0 0 12\"></path><path fill=\"#FFDA44\" d=\"M19.305 7.315v.3l.01.003z\"></path><path fill=\"#A2001D\" d=\"M23.044 15.13h-2.26l-.957 1.043v2.087H17.74v-1.043h1.043V15.13h-4.696v1.304h-1.043v-2.486a1.56 1.56 0 0 1-.522-1.166V5.999c0-.864.701-1.565 1.565-1.565v9.652h2.087l.716-.597a2.5 2.5 0 0 1-.194-.968v-1.565h-1.565v-3.13h3.13c0-.522.783-1.044.783-1.044s.783.522.783 1.043v3.131c.58.007 1.502-.008 2.499 0-.262-.458-.413-1-.413-1.565 0-.921.398-1.749 1.03-2.322a12.05 12.05 0 0 0-4.18-4.983h-7.806v19.826h7.807a12.03 12.03 0 0 0 4.693-6.332z\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }